import loadable from '@loadable/component'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import ResponsiveImage from 'components/Common/ResponsiveImage'

const HeaderMain = loadable(
  () =>
    import(
      '../../../client/components/App/Header/HeaderMain/HeaderMain'
    ),
)

const CollageImage = styled(ResponsiveImage)`
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
`

function ChatTripPlannerMobileBlocker() {
  const intl = useIntl()

  const aiTripPlannerLabel = intl.formatMessage({
    id: '0dIh0w1ETJ4Zlbp7YKsB',
    defaultMessage: 'AI TripPlanner',
    description: 'Branding label for the AI TripPlanner feature on mobile blocker page',
  })
  const comingSoonHeading = intl.formatMessage({
    id: 'iNEQATlY9_jU5ZapAs_f',
    defaultMessage: 'Coming soon to mobile',
    description: 'Heading on mobile blocker page indicating feature is not yet available on mobile',
  })
  const mobileBlockerBody = intl.formatMessage({
    id: 'CdXU_PC3QzlkojU9lpaa',
    defaultMessage: 'For the best experience, switch to a desktop or laptop to continue planning with AI.',
    description: 'Body text on mobile blocker page advising users to switch to desktop',
  })

  return (
    <>
      <HeaderMain />
      <Sheet padding="64 24 64 24">
        <Group direction="vertical" gap={48} fullWidth horizontalAlign="center">
          <Group direction="horizontal" gap={16} horizontalAlign="center" verticalAlign="end">
            <CollageImage id="jcijuct2hp3alt5b09jh" width={125} height={125} aspectRatio="1:1" quality="good" alt="" loading="lazy" />
            <CollageImage id="w5mfdwx7a0b9qtb4btj" width={169} height={169} aspectRatio="1:1" quality="good" alt="" style={{ marginBottom: rem(35) }} />
            <CollageImage id="8fht696ggwk0pnhryxe" width={125} height={125} aspectRatio="1:1" quality="good" alt="" loading="lazy" />
          </Group>
          <Group direction="vertical" gap={12} fullWidth horizontalAlign="center">
            <Heading variant="heading5" as="span">
              {aiTripPlannerLabel}
            </Heading>
            <Heading variant="heading3" align="center" as="h1">
              {comingSoonHeading}
            </Heading>
            <BodyText variant="medium" align="center">
              {mobileBlockerBody}
            </BodyText>
          </Group>
        </Group>
      </Sheet>
    </>
  )
}

export default ChatTripPlannerMobileBlocker
